import type { FC } from "react";
import {
    categoryIconFilter,
    categoryLinkFilter,
    i18nCategoryFilter,
    parentCategoryFilter,
    subCategoryFilter,
} from "../../../../filters/ngFilters";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { trackEvent } from "../SWReactTableTrackEvent";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

/**
 * @deprecated. please use app/components/React/Table/cells/category-cell/CategoryCell.tsx
 */
export const CategoryCell: FC<ITableCellProps> = ({ value, row, metadata, isIconHidden, ignoreCustomCat }) => {
    let isLinkable = true;
    if (!value || value === "null") {
        value = "N/A";
        isLinkable = false;
    } else if (value.trim() === "Unknown") {
        isLinkable = false;
    }
    const params = proNavigator.getParams();
    const isCustomCategory = UserCustomCategoryService.isCustomCategory(params.category);
    const href = isCustomCategory
        ? proNavigator.href("digitalsuite_marketresearch_webmarketanalysis_overview", {
              ...params,
              category: UserCustomCategoryService.getCustomCategoryByName(value)?.forUrl,
          })
        : categoryLinkFilter(proNavigator)(value, row.MainCategory, ignoreCustomCat);

    return (
        <div className="swTable-categoryCell">
            {isLinkable ? (
                <>
                    {!isIconHidden ? (
                        <i
                            className={`sprite-category u-right-padding-6 ${categoryIconFilter()(
                                parentCategoryFilter()(value),
                            )}`}
                        />
                    ) : null}
                    <a
                        title={i18nCategoryFilter()(value)}
                        href={row.href || href}
                        onClick={() => {
                            trackEvent(metadata, "Internal Link", value, "click");
                        }}
                    >
                        {subCategoryFilter()(value)}
                    </a>
                </>
            ) : (
                subCategoryFilter()(value)
            )}
        </div>
    );
};
CategoryCell.displayName = "CategoryCell";
